<template>
  <h2 class="pb-2 border-bottom">Bem-Estar e Hidratação</h2>
  <ul>
    <li>Hidratação IV – Eletrólitos e fluidos para recuperação da desidratação</li>
    <li>Imunidade Boost IV – Vitamina C, zinco e glutationa para suporte imunológico</li>
    <li>Detox IV – Glutationa, antioxidantes e fluidos para eliminar toxinas</li>
  </ul>

  <h2 class="pb-2 border-bottom">Energia e Melhoria de Desempenho</h2>
  <ul>
    <li>Coquetel de Myers – Magnésio, cálcio, vitaminas B e vitamina C para energia e bem-estar</li>
    <li>Recuperação de Atletas IV – Aminoácidos, B12 e hidratação para recuperação muscular</li>
    <li>Impulso de Energia B12 IV – Vitamina B12 para melhorar a energia e o metabolismo</li>
  </ul>

  <h2 class="pb-2 border-bottom">Beleza e Anti-Envelhecimento</h2>
  <ul>
    <li>Glow IV – Biotina, vitamina C e glutationa para saúde da pele, cabelo e unhas</li>
    <li>Anti-Envelhecimento IV – NAD+, glutationa e nutrientes que estimulam o colágeno</li>
  </ul>

  <h2 class="pb-2 border-bottom">Perda de Peso e Metabolismo</h2>
  <ul>
    <li>Queima de Gordura IV – L-carnitina, MIC (Metionina, Inositol, Colina) e vitaminas B para aumento do metabolismo</li>
    <li>Redefinição Metabólica IV – Aminoácidos, complexo de vitamina B e hidratação para gerenciamento de peso</li>
  </ul>

  <h2 class="pb-2 border-bottom">Recuperação e Alívio de Ressaca</h2>
  <ul>
    <li>Recuperação de Ressaca IV – Eletrólitos, vitaminas B e medicação anti-náusea</li>
    <li>Alívio de Enxaqueca e Estresse IV – Magnésio, vitaminas B e hidratação para alívio de dores de cabeça</li>
  </ul>
</template>

<script>
export default {
  name: 'IMIVVitaminTherapiesContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
